import { render, staticRenderFns } from "./InquiryProcessDropdown.vue?vue&type=template&id=04776acd&"
import script from "./InquiryProcessDropdown.vue?vue&type=script&lang=js&"
export * from "./InquiryProcessDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports